export const sections = [
  {
    title: "Shane Weber",
    meta: "effect 01: straight linear paths, smooth easing, clean timing, minimal rotation.",
    animationConfig: {
      // Default config - no special data attributes
    },
    items: [
      { id: 1, title: "Drift — A04", model: "Amelia Hart", imageUrl: "/assets/img1.webp" },
      { id: 2, title: "Veil — K18", model: "Irina Volkova", imageUrl: "/assets/img2.webp" },
      { id: 3, title: "Ember — M45", model: "Charlotte Byrne", imageUrl: "/assets/img3.webp" },
      { id: 4, title: "Gleam — S12", model: "Anastasia Morozova", imageUrl: "/assets/img4.webp" },
      { id: 5, title: "Bloom — J29", model: "Eva Ramirez", imageUrl: "/assets/img5.webp" },
      { id: 6, title: "Whisper — V87", model: "Milana Petrova", imageUrl: "/assets/img6.webp" },
      { id: 7, title: "Trace — Z05", model: "Sofia Carter", imageUrl: "/assets/img7.webp" },
      { id: 8, title: "Flicker — Q62", model: "Alina Kuznetsova", imageUrl: "/assets/img8.webp" },
      { id: 9, title: "Grain — H71", model: "Isabella Novak", imageUrl: "/assets/img9.webp" },
      { id: 10, title: "Pulse — B90", model: "Daria Sokolova", imageUrl: "/assets/img10.webp" },
      { id: 11, title: "Mist — L36", model: "Victoria Fields", imageUrl: "/assets/img11.webp" },
      { id: 12, title: "Shard — Y22", model: "Natalia Popova & Emily Stone", imageUrl: "/assets/img12.webp" },
      { id: 13, title: "Vapor — X79", model: "Yulia Orlova", imageUrl: "/assets/img13.webp" },
      { id: 14, title: "Glow — F13", model: "Camila Ford", imageUrl: "/assets/img14.webp" },
      { id: 15, title: "Flux — N48", model: "Sofia Mikhailova", imageUrl: "/assets/img15.webp" },
      { id: 16, title: "Spire — C65", model: "Ava Bennett", imageUrl: "/assets/img16.webp" }
    ]
  },
  {
    title: "Manika Jorge",
    meta: "effect 02: Adjusts mover count, rotation, timing, and animation feel.",
    animationConfig: {
      steps: 8,
      rotationRange: 7,
      stepInterval: 0.05,
      moverPauseBeforeExit: 0.25,
      moverEnterEase: "sine.in",
      moverExitEase: "power2",
      panelRevealEase: "power2"
    },
    items: [
      { id: 17, title: "Driftwood — W50", model: "Valeria Smirnova", imageUrl: "/assets/img17.webp" },
      { id: 18, title: "Fold — T81", model: "Emma Chase", imageUrl: "/assets/img18.webp" },
      { id: 19, title: "Shroud — E26", model: "Marina Belova", imageUrl: "/assets/img19.webp" },
      { id: 20, title: "Ripple — P34", model: "Chloe Martin", imageUrl: "/assets/img20.webp" },
      { id: 21, title: "Fray — U07", model: "Alexandra Dmitrieva", imageUrl: "/assets/img21.webp" },
      { id: 22, title: "Wane — R52", model: "Isabella Moore", imageUrl: "/assets/img22.webp" },
      { id: 23, title: "Tide — S33", model: "Ksenia Egorova", imageUrl: "/assets/img23.webp" },
      { id: 24, title: "Rift — G08", model: "Mia Anderson", imageUrl: "/assets/img24.webp" },
      { id: 25, title: "Spool — H94", model: "Anna Mikhailova", imageUrl: "/assets/img25.webp" },
      { id: 26, title: "Glitch — M70", model: "Emily Brown", imageUrl: "/assets/img26.webp" },
      { id: 27, title: "Slip — F02", model: "Ekaterina Ivanova", imageUrl: "/assets/img27.webp" },
      { id: 28, title: "Husk — C15", model: "Olivia Reed", imageUrl: "/assets/img28.webp" },
      { id: 29, title: "Blur — V86", model: "Sofia Lebedeva", imageUrl: "/assets/img29.webp" },
      { id: 30, title: "Fracture — A63", model: "Harper Gray", imageUrl: "/assets/img30.webp" },
      { id: 31, title: "Mote — Y39", model: "Elizaveta Petrova", imageUrl: "/assets/img31.webp" },
      { id: 32, title: "Aura — K21", model: "Lily Cooper", imageUrl: "/assets/img32.webp" }
    ]
  },
  {
    title: "Angela Wong",
    meta: "effect 03: Big arcs, smooth start, powerful snap, slow reveal.",
    animationConfig: {
      steps: 10,
      stepDuration: 0.3,
      pathMotion: "sine",
      sineAmplitude: 300,
      clipPathDirection: "left-right",
      autoAdjustHorizontalClipPath: true,
      stepInterval: 0.07,
      moverPauseBeforeExit: 0.3,
      moverEnterEase: "sine",
      moverExitEase: "power4",
      panelRevealEase: "power4",
      panelRevealDurationFactor: 4
    },
    items: [
      { id: 33, title: "Whorl — B45", model: "Anastasia Volkova", imageUrl: "/assets/img33.webp" },
      { id: 34, title: "Flicker — D17", model: "Sophia White", imageUrl: "/assets/img1.webp" },
      { id: 35, title: "Gleam — Z58", model: "Polina Sokolova", imageUrl: "/assets/img2.webp" },
      { id: 36, title: "Shard — J03", model: "Ava Mitchell", imageUrl: "/assets/img3.webp" },
      { id: 37, title: "Trace — Q29", model: "Maria Ivanenko", imageUrl: "/assets/img4.webp" },
      { id: 38, title: "Crush — W92", model: "Ella Foster", imageUrl: "/assets/img5.webp" },
      { id: 39, title: "Veil — X16", model: "Yulia Morozova", imageUrl: "/assets/img6.webp" },
      { id: 40, title: "Clasp — S84", model: "Charlotte Hayes", imageUrl: "/assets/img7.webp" },
      { id: 41, title: "Flint — T66", model: "Viktoria Kuznetsova", imageUrl: "/assets/img8.webp" },
      { id: 42, title: "Spire — E49", model: "Amelia Parker", imageUrl: "/assets/img9.webp" },
      { id: 43, title: "Plume — N22", model: "Daria Smirnova", imageUrl: "/assets/img10.webp" },
      { id: 44, title: "Hollow — B75", model: "Zoe Adams", imageUrl: "/assets/img11.webp" },
      { id: 45, title: "Brume — K10", model: "Anastasiya Orlova", imageUrl: "/assets/img12.webp" },
      { id: 46, title: "Crave — F37", model: "Mia Bennett", imageUrl: "/assets/img13.webp" },
      { id: 47, title: "Quiver — R19", model: "Natalia Volkova", imageUrl: "/assets/img14.webp" },
      { id: 48, title: "Fathom — L52", model: "Isabella Young", imageUrl: "/assets/img15.webp" }
    ]
  },
  {
    title: "Kaito Nakamo",
    meta: "effect 04: Quick upward motion with bold blending and smooth slow reveal.",
    animationConfig: {
      steps: 4,
      clipPathDirection: "bottom-top",
      stepDuration: 0.25,
      stepInterval: 0.06,
      moverPauseBeforeExit: 0.2,
      moverEnterEase: "sine.in",
      moverExitEase: "expo",
      panelRevealEase: "expo",
      panelRevealDurationFactor: 4,
      moverBlendMode: "hard-light"
    },
    items: [
      { id: 49, title: "Pulse — D61", model: "Sofia Makarova", imageUrl: "/assets/img16.webp" },
      { id: 50, title: "Fade — P42", model: "Scarlett James", imageUrl: "/assets/img17.webp" },
      { id: 51, title: "Wisp — T14", model: "Ekaterina Romanova", imageUrl: "/assets/img18.webp" },
      { id: 52, title: "Fragment — G77", model: "Aria Robinson", imageUrl: "/assets/img19.webp" },
      { id: 53, title: "Spiral — Y24", model: "Daria Petrova", imageUrl: "/assets/img20.webp" },
      { id: 54, title: "Trace — Z85", model: "Chloe Evans", imageUrl: "/assets/img21.webp" },
      { id: 55, title: "Flare — C11", model: "Sofia Orlova", imageUrl: "/assets/img22.webp" },
      { id: 56, title: "Chasm — R05", model: "Grace Walker", imageUrl: "/assets/img23.webp" },
      { id: 57, title: "Bloom — N38", model: "Yana Melnikova", imageUrl: "/assets/img24.webp" },
      { id: 58, title: "Shard — W20", model: "Mila Scott", imageUrl: "/assets/img25.webp" },
      { id: 59, title: "Mist — S12", model: "Natalia Ivanova", imageUrl: "/assets/img26.webp" },
      { id: 60, title: "Crush — E31", model: "Ava Thompson", imageUrl: "/assets/img27.webp" },
      { id: 61, title: "Ripple — F68", model: "Anastasia Novikova", imageUrl: "/assets/img28.webp" },
      { id: 62, title: "Gossamer — A07", model: "Madison Brooks", imageUrl: "/assets/img29.webp" },
      { id: 63, title: "Floe — K96", model: "Ekaterina Smirnova", imageUrl: "/assets/img30.webp" },
      { id: 64, title: "Shiver — V44", model: "Emily Robinson", imageUrl: "/assets/img31.webp" }
    ]
  }
];

// Panel content for first item
export const panelContent = {
  title: "murmur—207",
  description: "Beneath the soft static of this lies a fragmented recollection of motion—faded pulses echoing through time-warped layers of light and silence. A stillness wrapped in artifact."
};
